<template>
    <div class="flex">
        <div class="d-flex flex-column" style="gap: 1rem">
            <SearchLayout :get-data="searchByFavorites()" :is-favorite="true" :search-at-creation="true">
                <template #errors="{ props: { loading } }">
                    <div v-if="loading" class="box p-5" style="position: relative">
                        <b-loading :active="loading" :is-full-page="false" />
                    </div>
                    <b-notification active :closable="false" type="is-secondary is-warning is-light">
                        {{ $t('searchform.noRecordedFavoriteYet') }}
                    </b-notification>
                </template>
            </SearchLayout>
        </div>
    </div>
</template>

<script>
    import NlSearchFilters from '@/components/Search/NlSearchFilters'
    import { mapActions, mapGetters, mapState } from 'vuex'
    import LoginAs from '@/components/Admin/LoginAs.vue'
    import SearchLayout from '@/components/Search/SearchLayout.vue'
    import elasticUrlsRepository from '@/api/v2/elastic/url'

    export default {
        name: 'Favorites',
        title: 'favorites.title',
        props: {},
        components: {
            SearchLayout,
            LoginAs,
            NlSearchFilters
        },
        data() {
            return {
                favoritesLoading: false
            }
        },
        mounted() {
            this.getInfos()
            this.getUserInfos()
        },
        computed: {
            ...mapState({
                project: function (state) {
                    return state.project
                }
            }),
            ...mapGetters('auth', { user: 'user' }),
            ...mapState('search', {
                filters: 'filters',
                meta: 'meta'
            })
        },
        methods: {
            ...mapActions('auth', { getUserInfos: 'me' }),
            ...mapActions('auth', { getInfos: 'getInfos' }),

            searchByFavorites () {
                return elasticUrlsRepository.readUrlsByFavorites
            }
        }
    }
</script>
